import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { 
  NavigateBefore as PrevIcon, 
  NavigateNext as NextIcon 
} from '@mui/icons-material';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  disabled = false
}) => {
  const handlePrevious = () => {
    if (currentPage > 0 && !disabled) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1 && !disabled) {
      onPageChange(currentPage + 1);
    }
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        mt: 3,
        gap: 2
      }}
    >
      <Button
        onClick={handlePrevious}
        disabled={currentPage === 0 || disabled}
        startIcon={<PrevIcon />}
        variant="outlined"
        sx={{ 
          borderColor: '#3A3A3A',
          color: currentPage === 0 || disabled ? '#5A5A5A' : '#BB86FC',
          '&:hover': {
            borderColor: '#BB86FC',
            backgroundColor: 'rgba(187, 134, 252, 0.08)'
          }
        }}
      >
        Previous
      </Button>

      <Typography 
        variant="body2" 
        sx={{ 
          color: '#E0E0E0',
          fontWeight: 500,
          minWidth: 120,
          textAlign: 'center'
        }}
      >
        Page {currentPage + 1} of {totalPages}
      </Typography>

      <Button
        onClick={handleNext}
        disabled={currentPage >= totalPages - 1 || disabled}
        endIcon={<NextIcon />}
        variant="outlined"
        sx={{ 
          borderColor: '#3A3A3A',
          color: currentPage >= totalPages - 1 || disabled ? '#5A5A5A' : '#BB86FC',
          '&:hover': {
            borderColor: '#BB86FC',
            backgroundColor: 'rgba(187, 134, 252, 0.08)'
          }
        }}
      >
        Next
      </Button>
    </Box>
  );
};

export default Pagination; 